module.exports = require('react/lib/ReactTransitionGroup');


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-addons-transition-group/index.js
// module id = 199
// module chunks = 0